<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="resource-legend">
  <h3> Legenda: </h3>
  <span *ngIf="legendItems" class="legend-group">
        <span *ngFor="let item of legendItems" class="resource-legend-item">
            <span *ngIf="item.icon" [ngClass]="item.icon" [ngStyle]="{'color' : item.color}"
                  class="material-icons icon"></span>

            <span *ngIf="!item.icon" [ngStyle]="{background : item.color}" class="square icon"> </span>
          {{item.label}}
        </span>
    </span>


</div>
